<template>
  <div class="container my-account">
    <AccountResetPassword
      :auto-login="true"
      redirect="/"
    >
      <template #content>
        <h1 class="my-account__title heading heading--1">
          {{ $t('Create password') }}
        </h1>

        <div class="my-account__text">
          <p>
            {{ $t('Enter your password below to gain access to your account.') }}
          </p>
        </div>
      </template>
    </AccountResetPassword>
  </div>
</template>

<script setup>
import { useBreadcrumbs } from '~layers/app/composables/useBreadcrumbs.ts'

const { t } = useI18n({ useScope: 'global' })
const { setBreadcrumbs } = useBreadcrumbs()
setBreadcrumbs({
  label: t('Create Password'),
  parents: [],
})

const { pageView } = useDataLayer()
pageView('other', t('Create Password'))

useHead({
  meta: [
    { hid: 'robots', name: 'robots', content: 'noindex, follow' },
  ],
})
</script>
